import Dialog from '@/global/guides/Dialog'
import { hasPermission } from '@/hooks/useBackendMenu'
import { useCompensacaoManualOutletContext } from '@/pages/CompensacaoManual.context'
import {
    compensacaoManual,
    createCompensacaoManualSchema,
    UpdateCompensacaoManual,
} from '@/service/api'
import { useNavigate, useParams } from 'react-router-dom'
import { toast } from 'sonner'
import FormCompensacaoManual from '../forms/FormCompensacaoManual'

export default function EditarCompensacaoManualModal() {
    const { id } = useParams()
    const navigate = useNavigate()
    const { mutateAsync, isLoading } = compensacaoManual.mutations.useUpdate()

    const data = useCompensacaoManualOutletContext().data.get(Number(id))

    if (!data) return null

    function handleSubmit(input: UpdateCompensacaoManual) {
        mutateAsync(
            {
                id: Number(id),
                competencia: data!.competencia,
                ...input,
            } as any,
            {
                onSuccess: () => {
                    toast.success('Compensação manual atualizada com sucesso!')
                    navigate(-1)
                },
                onError: err => {
                    toast.error(
                        err.message || 'Erro ao atualizar compensação manual',
                    )
                },
            },
        )
    }

    return (
        <Dialog.Root
            width="2xl"
            onSubmit={handleSubmit}
            loading={isLoading}
            schema={createCompensacaoManualSchema.partial()}
            defaultValues={{
                tipo: data.tipo,
                data: data.data,
                competencia: data.competencia,
                empresaId: data.empresaId,
                funcionarioId: data.funcionarioId,
                calculoId: data.calculoId,
                destinos: data.Destinos?.map(d => ({ data: d.data })) || [],
            }}
            open={hasPermission(['update', 'CompensaçãoManual'])}
        >
            <Dialog.Title>Editar Compensação Manual</Dialog.Title>
            <Dialog.Content>
                <FormCompensacaoManual />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
